const localhostURL = url => {
	const domain = url.split(':')[0];

	return domain === 'localhost' ? domain : `.${domain}`;
};

export const cookiesHelper = (function cookiesHelper() {
	const cookiesH = {};
	let expires = '';
	cookiesH.current = document.cookie;

	cookiesH.get = name => {
		const nameEQ = `${name}=`;
		const ca = document.cookie.split(';');
		for (let i = 0; i < ca.length; i++) {
			let c = ca[i];
			while (c.charAt(0) === ' ') {
				c = c.substring(1, c.length);
			}
			if (c.indexOf(nameEQ) === 0) {
				return c.substring(nameEQ.length, c.length);
			}
		}
		return null;
	};

	// eslint-disable-next-line
	cookiesH.set = (name, value, days, path) => {
		if (days) {
			const date = new Date();
			date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
			expires = date.toGMTString();
		} else {
			expires = '';
		}

		const dir = path || '/';
		const noPortURL = window.location.host.split(':')[0];
		// After calling split on `.` on the location.host we should end up with a
		// single element such as `localhost`, 2 such is the case for lavu.com or
		// three with domains such as admin.lavu.com. The whole purpose of the logic
		// that follow is to extract the root domain `domain name` + `extension` so
		// cookies are set on the domain level and are accesible from other
		// subdomains. We doing this to allow cross-subdomain authentication with
		// php which will make cookie sessions be available across all subdomains
		// More information on Jira story https://jira.lavu.com/browse/CP3-412
		const URL = noPortURL.split('.');
		const includesLocalHost = window.location.host.includes('localhost');
		const domain = includesLocalHost
			? localhostURL(URL[0])
			: `.${URL.slice(1).join('.')}`;

		const cookie = `${name}=${value};expires=${expires};path=${dir};domain=${domain}`;

		document.cookie = cookie;
	};

	cookiesH.remove = function removeCookie(name) {
		this.set(name, '', -1);
	};

	return cookiesH;
})();
